import * as tslib_1 from "tslib";
import { dispatch, getState } from '@@/store';
import { Base64 } from 'js-base64';
import Hisoka from '@souche-f2e/hisoka-js';
export default function () {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        yield dispatch.global.loadSSOUser();
        if (getState().global.sso.isLogin !== true) {
            const { href } = window.location;
            const ssoHost = process.env.MUJI_APP_SSO_HOST;
            const hashStr = Base64.encodeURI(`${href}_@@__@@_${href}`);
            window.location.href = `http://${ssoHost}/login.htm?s=${hashStr}`;
        }
        yield dispatch.menu.loadMenuList();
        Hisoka.load({
            appName: 'work-platform',
            platform: 'PLATFORM_ARCH_SERVICE',
            usertag: getState().global.sso.userInfo.iid,
            env: 'production',
            routes: [],
        });
    });
}
